import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { settings } from '../settings';



export default function HeaderHook() {

    useEffect(() => {
        
    }, []);



    return (
        <>
            <Button  variant="outline-light" href={settings.supportLink || '#'} target="_blank" rel="noopener noreferrer">Supporto </Button>
        </>
    )
};